"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentedControl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lib_1 = require("../../lib");
const SegmentedControl = ({ options, onChange, value, className }) => {
    const handleClick = (newValue) => () => {
        if (newValue === value)
            return;
        if (onChange)
            onChange(newValue);
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)('segmented-control', className) }, { children: options.map((option, index) => ((0, jsx_runtime_1.jsx)("button", Object.assign({ type: "button", tabIndex: -1, className: (0, lib_1.bem)('segmented-control__btn', (0, lib_1.use)(value === option.value, '--active')), onClick: handleClick(option.value) }, { children: option.label }), index))) }), void 0));
};
exports.SegmentedControl = SegmentedControl;
//# sourceMappingURL=SegmentedControl.js.map